import cn from 'classnames';
import styles from '~/style/aigallery/aIDevelopmentResources.module.less';
import {aIDevelopmentResources as data, moduleTitleCn, moduleContentCn} from '~/locals/aigallery/index';
import {ArrowBtn} from './components';

import {useCptDuration} from '~/utils/trackCptDuration/hook';
import {applicationName} from '~/utils/trackCptDuration/constants';
const id = 'aiDevelopmentResources';
const AIDevelopmentResources = () => {
    useCptDuration(id, {
        name: `${applicationName}-全面的AI开发资源-停留时长`
    });
    return (
        <div className={styles.container} id={id}>
            <div className={cn(styles.title, `${moduleTitleCn}`)}>{data.title}</div>
            <div className={`${moduleContentCn}`}>
                <div className={cn(styles.info)}>
                    {data.infoArray.map((item, index) => {
                        return (
                            <div
                                className={styles['info-item']}
                                key={index}
                                onClick={() => {
                                    if (typeof window !== 'undefined') {
                                        window?.open?.(item.link, '_blank');
                                    }
                                }}
                                {...item.trackInfo}
                            >
                                <img src={item.icon} alt="" className={styles['info-item-icon']} />
                                <div className={styles['info-item-title']}>{item.title}</div>
                                <div className={styles['info-item-desc']}>{item.description}</div>
                                <ArrowBtn
                                    data={{
                                        link: item.link,
                                        text: '了解更多',
                                        third: true
                                    }}
                                />
                            </div>
                        );
                    })}
                </div>
                <div className={styles.nav}>
                    {data?.nav.map(item => (
                        <div
                            className={styles['nav-item']}
                            onClick={() => {
                                if (typeof window !== 'undefined') {
                                    window?.open?.(item.link, '_blank');
                                }
                            }}
                            {...item.trackInfo}
                        >
                            <img src={item.icon} alt="" className={styles['nav-item-icon']} />
                            <div>
                                <div className={styles['nav-item-title']}>{item.title}</div>
                                <div className={styles['nav-item-subTitle']}>{item.subTitle}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AIDevelopmentResources;
